// extracted by mini-css-extract-plugin
module.exports = {"scrollBarWrapper":"Scrollbar_scrollBarWrapper__0NZFB","scrollbar":"Scrollbar_scrollbar__cJ_uB"};